/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";


/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../../contexts/userContext";
import { useGeneralService } from "../../../services/generalService";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as MailIconSvg } from '../../../resources/images/mail-icon.svg';


/* Styles */
import styles from "./styles";


const InviteGuestModal = ({showModal, setShowModal, travelerName, inviteGuest}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [teams, setTeams] = useState([]);
  const [defaultTeam, setDefaultTeam] = useState([]);

  const { getTeams } = useGeneralService();
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const handleInviteGuest = async (values) => {
    const response = await inviteGuest(values)
    if (response) {
      setShowModal(false)
    }
  }
  useEffect(() => {
    (async () => {
      const responseTeams = await getTeams();
      if (responseTeams) {
        setTeams(responseTeams?.managedgroups);
        setDefaultTeam(responseTeams?.managedgroups.find(item => item.default === true))
      }
    })();
  }, [showModal])

  return (
      <UCModal
        className={classes.inviteGuestModal}
        showModal={ showModal }
        setShowModal={ setShowModal }
        modalIcon={ <MailIconSvg /> }
        modalTitle={ <FormattedMessage id="safetyInviteGuest.title"/> }
        modalDescription={ <FormattedMessage id={`safetyInviteGuest.description.${providerCode}`} values={{name: travelerName}}/> }
        modalContent={ <Content setShowModal={setShowModal} handleSubmit={handleInviteGuest} teams={teams} defaultTeam={defaultTeam} /> }
        dataTestId="inviteGuestModal"
      />
  )
}

export default InviteGuestModal;
